/**
 * Opens a link with a function
 *
 * Ex: openLink("spocket.co", "_top")
 *
 * @param  { String } url
 * @param  { String } target default "_blank"
 * @returns { null }
 *
 */
export function openLink(url, target = "_blank") {
  try {
    const win = window.open(url, target, "noopener,noreferrer");
    if (win) {
      win.opener = null;
      win.focus();
    }
  } catch (e) {
    // PayPal SDK intercepts window.open for _blank targets and throws when
    // another window is already linked. Fall back to direct navigation.
    window.location.assign(url);
  }
}
